import { Flex, LoadingSpinner, Stack, Text } from '@homebotapp/hb-react-component-catalog'
import { ListingCardNew } from '../ListingCardNew/ListingCardNew'
import { ListingCompact } from '../../../api/gqlaxy/gql/generated/graphql'
import { defineMessages, useIntl } from 'react-intl'

interface GalleryListProps {
  listings?: ListingCompact[]
  isLoading?: boolean
}

export const MSG = defineMessages({
  noListingFound: {
    id: 'General.noListingFound',
    defaultMessage: 'No listings found'
  }
})

export const GalleryList = ({ listings, isLoading }: GalleryListProps) => {
  const intl = useIntl()
  if (isLoading) {
    return <LoadingSpinner variant='bot-head' size='lg' position='relative' />
  }

  if (!listings?.length) {
    return <Text>{intl.formatMessage(MSG.noListingFound)}</Text>
  }

  return (
    <Flex
      ml={[0, 0]}
      mb={[0, 4]}
      direction={['column', 'row']}
      width='100%'
      height={['auto', '325px']}
      justifyContent='space-between'
    >
      <Stack pr={[8, 0]} spacing={3} direction='row' width='100%' overflowX='auto' flexWrap='nowrap'>
        {listings?.map(listing => <ListingCardNew key={listing.id} listing={listing} />)}
      </Stack>
    </Flex>
  )
}
